import { useSetRecoilState } from "recoil";
import { useEffect } from "react";
import { AlertState } from "states";
import { axiosPrivateInstanceForm } from "../axios";
import useAuth from "./useAuth";
import useRefreshToken from "./useRefreshToken";

export default function useAxiosPrivateForm() {
  const { accessToken, setAccessToken, csrftoken, user } = useAuth();
  const refresh = useRefreshToken();
  const setAlert = useSetRecoilState(AlertState);

  useEffect(() => {
    const requestIntercept = axiosPrivateInstanceForm.interceptors.request.use(
      (config) => {
        if (!config.headers["Authorization"]) {
          config.headers["Authorization"] = `Bearer ${accessToken}`;
          config.headers["X-CSRFToken"] = csrftoken;
          config.headers["Content-Type"] = "multipart/form-data";
        }

        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept =
      axiosPrivateInstanceForm.interceptors.response.use(
        (response) => response,
        async (error) => {
          const prevRequest = error?.config;
          if (error.response && error.response.status === 500) {
            setAlert({
              alert: true,
              message: "Đã xảy ra lỗi 500. Vui lòng thử lại sau.",
              type: "error",
            });
            return;
          } else if (
            (error?.response?.status === 403 ||
              error?.response?.status === 401) &&
            !prevRequest?.sent
          ) {
            prevRequest.sent = true;
            try {
              const { csrfToken: newCSRFToken, accessToken: newAccessToken } =
                await refresh();
              setAccessToken(newAccessToken);
              prevRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
              prevRequest.headers["X-CSRFToken"] = newCSRFToken;
              prevRequest.headers["Content-Type"] = "multipart/form-data";
              return axiosPrivateInstanceForm(prevRequest);
            } catch (refreshError) {
              return Promise.reject(refreshError);
            }
          }
          return Promise.reject(error);
        }
      );

    return () => {
      axiosPrivateInstanceForm.interceptors.request.eject(requestIntercept);
      axiosPrivateInstanceForm.interceptors.response.eject(responseIntercept);
    };
  }, [accessToken, user]);

  return axiosPrivateInstanceForm;
}
